import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { format } from "date-fns";
import { useFieldValue } from "formik";
import * as Yup from "yup";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { Maybe } from "../models/generated/graphql";
import { getAssessmentDate } from "../utils/agreement-utils";
import renderDateMessage from "../utils/render-date-message";
import { GeneralFieldController } from "./general-field-controller";

export class TherapyStartDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translate: (key: string) => string): Yup.AnySchema {
		if (!this.parent.context.startingPoint) {
			return super.createValidationRule(initialData, translate);
		}

		const minTherapyStartDate = getAssessmentDate(this.parent.context.startingPoint)!;

		return this.createFieldValidationRuleByDataType(translate).when(AttributeIdentifiers.ResponseReceived, {
			is: true,
			then: (schema) =>
				schema
					.required(({ path }) => renderDateMessage(path, translate))
					.min(minTherapyStartDate, `${translate("must-be-rrd-or-after")} - ${format(minTherapyStartDate, "dd.MM.yyyy")}`)
					.max(new Date(), translate("cannot-be-greater-than-today")),
		});
	}

	override useControlProps(): Maybe<FlexControlProps> {
		const [responseReceived] = useFieldValue(AttributeIdentifiers.ResponseReceived);

		return {
			minDate: this.parent.context.startingPoint && getAssessmentDate(this.parent.context.startingPoint),
			disabled: !responseReceived,
			cannotBeFuture: true,
		};
	}
}
